import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import StatsSection from './components/StatsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <SEOHead
        title="太阳娱乐 - 顶级娱乐平台官网入口 | 太阳娱乐官网"
        description="太阳娱乐是您值得信赖的综合娱乐平台，提供丰富多彩的娱乐项目与极致体验。太阳娱乐汇聚海量精品内容，安全稳定，服务专业，7×24小时全天候陪伴，立即加入太阳娱乐，开启您的精彩娱乐之旅。"
        keywords="太阳娱乐,太阳娱乐官网,太阳娱乐平台,太阳娱乐入口,太阳娱乐注册,太阳娱乐登录,太阳娱乐最新活动"
      />
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebSite" />
      <SchemaOrg type="WebPage" data={{
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: '太阳娱乐 - 顶级娱乐平台官网入口',
        url: 'https://hznaweisi.cn',
        description: '太阳娱乐是您值得信赖的综合娱乐平台，提供丰富多彩的娱乐项目与极致体验。',
        isPartOf: {
          '@type': 'WebSite',
          name: '太阳娱乐',
          url: 'https://hznaweisi.cn',
        },
      }} />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryGrid />
          <FeaturedArticles />
          <StatsSection />
          <FAQSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}